import React, { useState } from 'react';
import styled from 'styled-components';
import { Loader2, Button, SelectInput, ModalConfirm } from 'components';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import picto_past from 'images/picto_past.svg';
import picto_del from 'images/picto_del.svg';
import picto_copy from 'images/picto_copy.svg';
import axios from 'axios';
import picto_unwrap from 'images/picto_unwrap.svg';
import picto_roll_up from 'images/picto_roll_up.svg';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: 10px;
	margin-top: 20px;

	h2 {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}
	
	h3 {
		margin: 0 !important;
	}

	textarea {
		height: 160px !important;
		resize: none;
	}

	div.borders {
		border: 1px solid ${props => props.theme.placeholderColor};
		border-radius: 5px;
		padding: 10px;
		max-width: 100%;
		overflow-x: auto;
	}

	.select_container__Api {
		width: 230px;
	}
`;

const Row = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 10px;
	width: 100%;
	position: relative;
	overflow: visible;
	
	@media (min-width: 660px) {
		flex-direction: row;
		gap: 20px;
		justify-content: space-between;
	}
`;

const RowM = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 10px;
	position: relative;
	overflow: visible;
	
	> * {
		display: flex;
		flex-direction: row;
		gap: 8px;
	}
	
	@media (min-width: 660px) {
		flex-direction: row;
		gap: 20px;
	}

	a, a.active {
		color: ${props => props.theme.darkBlue} !important;
		font-family: "PT Sans";
	}
`;

const ScrollBox = styled.div`
	height:150px;
	min-height: 150px;
	overflow-y: auto;
	overflow-x: auto;
	flex-shrink: 0;
	flex-grow: 1;
	flex-basis: 10px;
	border: 1px solid ${props => props.theme.placeholderColor};
	border-radius: 5px;
	padding: 5px 0px 5px 5px;
	max-width: 100%;
`;

export const RequestForm = () => {
	const { t } = useTranslation();
	const [ sRequest, setSRequest ] = useState('');
	const [ sResponse, setResponse ] = useState('');
	const [ isOpened, setIsOpened ] = useState(false);
	const [ loading, setLoading ] = useState(false);
	const [ api, setApi ] = useState('TEST');
	const [ confirmProps, setConfirmProps ] = useState({});


	const apiOptions = [
		{ value: 'TEST', label: t('на тестовой системе') },
		{ value: 'PROD', label: t('на продуктиве!') },
	];

	const apiBind = {
		value: apiOptions.find(i => i.value === api) ?? null,
		options: apiOptions,
		onChange: option => {
			setApi(option.value);
		},
		name: 'Api'
	};

	const Bind = {
		value: sRequest,
		onChange: e => setSRequest(e.target.value),
		className: 'textInput'
	};

	const getRequest = () => {

		if (sRequest.length > 0) {

			if (api === 'PROD') {
				setConfirmProps({
					isVisible: true,
					title: t('Внимание!'),
					text: t('Метод будет выполнен на продуктивной системе! Вы уверены?'),
					onConfirm: () => {
						runRequest(true);
						setConfirmProps(false);
					},
					onCancel: () => setConfirmProps(false),
				});
			}
			else {	
				runRequest();
			}

		}

	};

	const runRequest = () => {
		if (sRequest.length > 0) {

			setLoading(true);

			axios.post(
				api === 'TEST' ? '/rapi00' : '/rapi99',
				{
					'XML': sRequest
				},
				{
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					}
				}
			)
				.then(resp => resp.data)
				.then(data => {
					setResponse(data);
					setLoading(false);
				});

		}

	};

	const onPast = () => {
		navigator.clipboard.readText()
			.then(text => {
				// `text` содержит текст, прочитанный из буфера обмена
				setSRequest(text);
			})
			.catch(err => {
				// возможно, пользователь не дал разрешение на чтение данных из буфера обмена
				console.log('Something went wrong', err);
			});
	};

	const onClear = () => {
		setSRequest('');
	};

	const onCopy = async () => {
		try {
			await navigator.clipboard.writeText(sResponse);
		} catch (error) {
			console.error(error.message);
		}
	};

	const onOpen = () => {
		setIsOpened(!isOpened);
	};

	return (
		<Container>
			<RowM>
				<h2>{t('Выполнить метод')}</h2>
				<div><SelectInput {...apiBind} /></div>
			</RowM>

			<Row>
				<h3>{t('Текст запроса')}</h3>
				<RowM>
					<NavLink rel="noreferrer" onClick={onPast}>
						<img src={picto_past} alt="" /> {t('Вставить')}</NavLink>
					<NavLink rel="noreferrer" onClick={onClear}>
						<img src={picto_del} alt="" /> {t('Очистить')}</NavLink>
				</RowM>
			</Row>

			<textarea {...Bind} />

			<Row>
				<div></div>
				<Button gradient onClick={getRequest}>{t('Отправить')}</Button>
			</Row>

			{loading && <Loader2 />}

			{sResponse?.length > 0 && <>
				<div className='col-1 margin-bottom-20' />
				<Row>
					<h3>{t('Ответ')}</h3>
					<RowM>
						<NavLink rel="noreferrer" onClick={onCopy}>
							<img src={picto_copy} alt="" /> {t('Копировать')}</NavLink>
						<NavLink rel="noreferrer" onClick={onOpen}>
							<img src={isOpened ? picto_roll_up : picto_unwrap} alt="" />
							{isOpened ? t('Свернуть') : t('Развернуть')}</NavLink>
					</RowM>
				</Row>

				{ isOpened ?
					<div className='borders'>
						<pre>
							{sResponse}
						</pre>
					</div>
					:
					<ScrollBox>
						<pre>
							{sResponse}
						</pre>
					</ScrollBox>
				}
			</>}

			<ModalConfirm {...confirmProps} />

		</Container>
	);
};
